import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Building, Clock, CheckCircle2 } from "lucide-react";

export const InvestmentOpportunity = () => {
  return (
    <Card className="bg-gradient-to-br from-primary/5 to-background border-primary/20">
      <CardHeader>
        <CardTitle className="text-xl text-primary">Investment Opportunity</CardTitle>
      </CardHeader>
      <CardContent className="space-y-6">
        <div className="text-center max-w-3xl mx-auto">
          <h3 className="text-2xl font-bold mb-6">$5M SAFE Note Agreement</h3>
          <p className="text-muted-foreground text-lg">
            We are ADGM based with SAFE note agreement structure, offering a unique opportunity for strategic investment.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-8">
          <Card className="bg-muted/50 border-primary/10">
            <CardContent className="p-6">
              <div className="flex items-center gap-4">
                <div className="p-3 rounded-full bg-primary/10">
                  <Building className="w-6 h-6 text-primary" />
                </div>
                <div>
                  <h4 className="font-semibold text-lg">ADGM Based</h4>
                  <p className="text-muted-foreground">
                    Regulated under Abu Dhabi Global Market
                  </p>
                </div>
              </div>
            </CardContent>
          </Card>

          <Card className="bg-muted/50 border-primary/10">
            <CardContent className="p-6">
              <div className="flex items-center gap-4">
                <div className="p-3 rounded-full bg-primary/10">
                  <Clock className="w-6 h-6 text-primary" />
                </div>
                <div>
                  <h4 className="font-semibold text-lg">18 Months Runway</h4>
                  <p className="text-muted-foreground">
                    Sustainable operational timeline
                  </p>
                </div>
              </div>
            </CardContent>
          </Card>

          <Card className="bg-muted/50 border-primary/10">
            <CardContent className="p-6">
              <div className="flex items-center gap-4">
                <div className="p-3 rounded-full bg-primary/10">
                  <CheckCircle2 className="w-6 h-6 text-primary" />
                </div>
                <div>
                  <h4 className="font-semibold text-lg">30% Committed</h4>
                  <p className="text-muted-foreground">
                    Soft commitment secured
                  </p>
                </div>
              </div>
            </CardContent>
          </Card>
        </div>
      </CardContent>
    </Card>
  );
};